import React from 'react';
import PropTypes from 'prop-types';
import formatShortDate from 'src/common/utils/Dates/formatShortDate';

const ShortDates = ({ startDate, endDate }) => (
  <>
    {(startDate !== endDate) && `${formatShortDate(startDate)} - `}
    {formatShortDate(endDate)}
  </>
);

ShortDates.propTypes = {
  endDate: PropTypes.string.isRequired,
  startDate: PropTypes.string,
};

ShortDates.defaultProps = {
  startDate: null,
};

ShortDates.equals = (propsA, propsB) => propsA.startDate === propsB.startDate && propsA.endDate === propsB.endDate;

export default ShortDates;
